<template>
  <div class="reassessment-summary small-text">
    <div class="font-weight-bold">Reassessment ก่อนกลับบ้าน</div>
    <div>
      Bleeding <b>{{ yesNo(r.bleeding) }}</b
      ><span v-if="r.bleedingDetail"> ({{ r.bleedingDetail }})</span> · Pain
      <b>{{ r.painScore }}/10</b> · Swelling <b>{{ yesNo(r.swelling) }}</b
      ><span v-if="r.swellingDetail"> ({{ r.swellingDetail }})</span> · General
      <b>{{
        r.generalCondition === "STABLE" ? "Stable" : "Dizziness / Syncope"
      }}</b
      ><span v-if="r.generalDetail"> ({{ r.generalDetail }})</span> ·
      Allergic/adverse <b>{{ yesNo(r.allergicReaction) }}</b
      ><span v-if="r.allergicDetail"> ({{ r.allergicDetail }})</span> ·
      Instruction <b>{{ instructions }}</b> · Discharge
      <b>{{ time(r.dischargeDt) }}</b>
    </div>
    <div v-if="assessor" class="description text-muted">
      ประเมินโดย {{ assessor }}
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "ReassessmentSummary",
  props: {
    r: { type: Object, required: true },
  },
  computed: {
    instructions() {
      const out = [];
      if (this.r.instructionVerbal) out.push("Verbal");
      if (this.r.instructionWritten) out.push("Written");
      return out.join(", ");
    },
    assessor() {
      const u = this.r.assessorU;
      return u ? `${u.firstNameTh} ${u.lastNameTh}` : "";
    },
  },
  methods: {
    yesNo(v) {
      return v ? "Yes" : "No";
    },
    time(dt) {
      return dt ? moment(dt).format("HH:mm") : "";
    },
  },
};
</script>
